import {useState, useEffect, useRef} from 'react';
import Calender from 'react-calendar';

import onClickFunctionKeys from '../../../utils/pagination';
import styles from './styles/list.module.css';
import './styles/calendar.css';

import FeedbackTable from './FeedbackTable';
import Pagination from '../../common/Pagination';
import DropdownFilter from '../../common/filter/DropdownFitler';
import InputFilter from '../../common/filter/InputFilter';

import {ReactComponent as NegativeIcon} from '../../../assets/feedback/negative.svg';
import {ReactComponent as PositiveIcon} from '../../../assets/feedback/positive.svg';
import {ReactComponent as NegativeActiveIcon} from '../../../assets/feedback/negative-active.svg';
import {ReactComponent as PositiveActiveIcon} from '../../../assets/feedback/positive-active.svg';
import {ReactComponent as CalendarIcon} from '../../../assets/feedback/calendar.svg';
import {ReactComponent as ResetIcon} from '../../../assets/feedback/reset.svg';

export default function FeedbackList({ f_type, state, s_type, start_date, end_date, employee, content, listResponse, listErrorResponse, pagination, listLoading, handleChange }) {
    const calendarRef = useRef(null);

    const [openDropDowns, setOpenDropDowns] = useState({
        state: false,
        type: false,
        calendar: false,
        content: false
    });

    const [selectedState, setSelectedState] = useState('전체');
    const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
    const [formattedDateRange, setFormattedDateRange] = useState('');
    const [isSingleDate, setIsSingleDate] = useState(true);
    const [pageNumbers, setPageNumbers] = useState([]);
    const [prevPageNumberLength, setPrevPageNumberLength] = useState(pageNumbers.length);

    const handleDropDowns = (key) => {
        setOpenDropDowns(prevState => ({
            ...prevState,
            [key]: !prevState[key]
        }));
    };

    const changeType = (s_type) => {
        if (s_type === 'LLM') return 'LLM';
        if (s_type === 'SQL') return 'SQL';
        if (s_type === 'DOCUMENT') return '문서';
        if (s_type === null) return '전체';
    };

    const removeTime = (date) => {
        const newDate = new Date(date);
        newDate.setHours(0, 0, 0, 0);

        return newDate;
    };

    const formatDateRange = (startDate, endDate) => {
        const format = (date) => {
            const year = date.getFullYear();
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const day = ('0' + date.getDate()).slice(-2);
            return `${year}.${month}.${day}`;
        };

        return (
            startDate.getTime() === endDate.getTime()
                ? `${format(startDate)}`
                : `${format(startDate)}-${format(endDate)}`
        );
    };

    const formatDateForSaving = (date) => {
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // 월은 0부터 시작하므로 +1
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}${month}${day}`;
    };

    const changeDate = (date) => { // 날짜 선택 모드 변경 (단일 ⟷ 기간)
        if (isSingleDate) {
            setSelectedDateRange([date, date]);
        } else {
            setSelectedDateRange((prevDates) => [prevDates[0], date]);
        }
        setIsSingleDate(!isSingleDate);
    };

    const saveDateRange = () => {
        let startDateWithoutTime = removeTime(selectedDateRange[0]);
        let endDateWithoutTime = removeTime(selectedDateRange[1]);

        if (startDateWithoutTime.getTime() > endDateWithoutTime.getTime()) { // 날짜 비교 후 빠른 날짜를 start_date, 느린 날짜를 end_date로 설정
            [startDateWithoutTime, endDateWithoutTime] = [endDateWithoutTime, startDateWithoutTime];
        }

        const formattedStartDate = formatDateForSaving(startDateWithoutTime);
        const formattedEndDate = formatDateForSaving(endDateWithoutTime);

        const resultDateRange = formatDateRange(startDateWithoutTime, endDateWithoutTime);
        setFormattedDateRange(resultDateRange);

        handleChange({ target: { name: 'start_date', value: formattedStartDate } });
        handleChange({ target: { name: 'end_date', value: formattedEndDate } });

        setIsSingleDate(true);
        handleDropDowns('calendar');
    };

    const resetDateRange = () => {
        setSelectedDateRange([null, null]);
        setFormattedDateRange('');
        handleChange({ target: { name: 'start_date', value: null } });
        handleChange({ target: { name: 'end_date', value: null } });
        handleDropDowns('calendar');
    };

    const stateMap = [
        { name: '대기 중', value: 'NEW' },
        { name: '확인 중', value: 'PROGRESS' },
        { name: '해결 완료', value: 'COMPLETED' },
        { name: '전체', value: null }
    ];

    const typeMap = [
        { name: 'LLM', value: 'LLM' },
        { name: 'SQL', value: 'SQL' },
        { name: '문서', value: 'DOCUMENT' },
        { name: '전체', value: null }
    ];

    const contentMap = [
        { name: '의도와 다른 답변', value: '의도와 다른 답변' },
        { name: '사실이 아닌 답변', value: '사실이 아닌 답변' },
        { name: '부족하거나 과한 답변', value: '부족하거나 과한 답변' },
        { name: '자연스럽지 않은 문장', value: '자연스럽지 않은 문장' },
        { name: '답이 나오지 않음', value: '답이 나오지 않음' },
        { name: '전체', value: null }
    ];


    const requestPagination = (page) => {
        handleChange({ target: { name: 'page', value: page } });
    };

    const handleClickPaginationFunctionKeys = (functionKey) => {
        requestPagination(onClickFunctionKeys(functionKey, pageNumbers, pagination.currentPage));
    };

    const initializePagination = () => {
        setPrevPageNumberLength(pageNumbers.length);
        let pages = Array.from({ length: pagination.totalPages }, (_, i) => i + 1);
        setPageNumbers(pages);
    };

    const clickOutside = (event) => {
        if (calendarRef.current && !calendarRef.current.contains(event.target)) {
            setOpenDropDowns(prevState => ({
                ...prevState,
                calendar: false
            }));
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', clickOutside);

        return () => {
            document.removeEventListener('mousedown', clickOutside);
        };
    }, []);

    useEffect(() => {
        if (!pagination) return;
        initializePagination();
    }, [pagination]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.containerFilter}>
                <div className={styles.contentTypeFilter}>
                    <button className={f_type === 'NEGATIVE' ? `${styles.btnTapInactive} ${styles.btnTapActive}` : `${styles.btnTapInactive}`}
                            onClick={() => handleChange({ target: { name: 'f_type', value: 'NEGATIVE' } })}
                    >
                        {f_type === 'NEGATIVE' ? <NegativeActiveIcon/> : <NegativeIcon/>}
                        불만족
                    </button>
                    <button className={f_type === 'POSITIVE' ? `${styles.btnTapInactive} ${styles.btnTapActive}` : `${styles.btnTapInactive}`}
                            onClick={() => handleChange({ target: { name: 'f_type', value: 'POSITIVE' } })}
                    >
                        {f_type === 'POSITIVE' ? <PositiveActiveIcon/> : <PositiveIcon/>}
                        만족
                    </button>
                </div>
                <div className={styles.contentFilter} ref={calendarRef}>
                    <DropdownFilter type='feedback-state'
                                    itemMap={stateMap}
                                    name='state'
                                    handleChange={handleChange}
                    />
                    <div className={styles.contentInput} ref={calendarRef}>
                        <CalendarIcon datatype='calendar' onClick={() => handleDropDowns('calendar')}/>
                        <input placeholder='날짜를 선택하세요'
                               value={formattedDateRange}
                               onClick={() => handleDropDowns('calendar')}
                               readOnly
                        />
                        {openDropDowns.calendar &&
                            <div className={styles.contentCalendar}>
                                <Calender selectRange={true}
                                          onClickDay={changeDate} // 날짜 클릭 이벤트 처리
                                          formatDay={(locale, date) => date.getDate()} // 날짜를 숫자로만 표시 (1일 -> 1)
                                />
                                <div className={styles.boxBtn}>
                                    <button className={styles.btnReset} onClick={resetDateRange}>
                                        초기화
                                        <ResetIcon/>
                                    </button>
                                    {selectedDateRange[0] || selectedDateRange[1]
                                        ? <button className={styles.btnSave} onClick={saveDateRange}>저장</button>
                                        : <button className={`${styles.btnSave} ${styles.btnSaveInactive}`}>저장</button>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    <div datatype='employee' ref={calendarRef}>
                        <InputFilter type='feedback-employee'
                                     placeholder='사번을 입력하세요'
                                     name='employee'
                                     value={employee}
                                     handleChange={handleChange}
                        />
                    </div>
                    <div ref={calendarRef}>
                        <DropdownFilter type='feedback-content'
                                        itemMap={contentMap}
                                        name='content'
                                        handleChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <FeedbackTable state={state}
                           s_type={s_type}
                           start_date={start_date}
                           end_date={end_date}
                           employee={employee}
                           content={content}
                           listResponse={listResponse}
                           listErrorResponse={listErrorResponse}
                           listLoading={listLoading}
            />
            {pagination && <Pagination prevPageNumberLength={prevPageNumberLength} pageNumbers={pageNumbers} currentPage={pagination.currentPage} handleChangePage={requestPagination} handleClickFunctionKeys={handleClickPaginationFunctionKeys}/>}
        </div>
    );
}
